
















import Vue from "vue";
import VQuaggaWrapper from "@/components/UI/VQuaggaWrapper.vue";
import { CodeResult } from "@/util/componentTypes";

export default Vue.extend({
  name: "VScanner",
  components: { VQuaggaWrapper },
  methods: {
    detected(result: CodeResult): void {
      if (result.codeResult.code.match(/\w?\d+-\d+/)) {
        this.$emit("detected", result);
      }
    }
  },
  data(): { scannerWidth: number } {
    return {
      scannerWidth: Math.floor(window.screen.width * window.devicePixelRatio * 0.6)
    };
  }
});
